// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5896":"d7e0d72c","8529":"d7e0d72c","9699":"200d0660"}[chunkId] + ".chunk.css";
};